<template>
  <!-- <v-list-item :key="client.cid" :ripple="false" :selectable="false" :inactive="true">
    <v-list-item-content>
      <v-list-item-subtitle class="subtitle-2" v-text="line1"></v-list-item-subtitle>
      <v-list-item-title class="subtitle-2 font-weight-ligh" v-text="line2"></v-list-item-title>
    </v-list-item-content>
  </v-list-item>-->
  <div class="pt-1 pb-1">
    <v-list-item-subtitle class="subtitle-2" v-text="line1"></v-list-item-subtitle>
    <v-list-item-title class="subtitle-2 font-weight-ligh" v-text="line2"></v-list-item-title>
  </div>
</template>


<script>
export default {
  name: "ClientItemThin",
  props: {
    client: Object,
    inFilteredMode: Boolean
  },
  data() {
    return {
      //showingAllTypes: false
    };
  },
  computed: {
    line1() {
      return `${this.client.city}, ${this.client.addressLine1}`;
    },
    line2() {
      return `${this.client.firstName} ${this.client.lastName} ${this.client
        .postcode || "no postcode"}`;
    }
  },
  methods: {}
};
</script>

<style scoped>
.border {
  border: 4px dashed red;
}
</style>
